<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('cli-areainteresse') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t('vendas') : $t('agro')
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'cli-areainteresse-list',
                                            })
                                        "
                                        >{{ $t('cli-areainteresse') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id && areaInteresse.descricao
                                            ? $route.params.id + ' - ' + areaInteresse.descricao
                                            : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToPage"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao && !isUpdate && permissao.create) ||
                                (!usuarioIntegracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(3)"
                                ref="idareainteresseerpInput"
                                v-model="areaInteresse.idareainteresseerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-7">
                            <v-input
                                :id="generateId(10)"
                                ref="nomeInput"
                                v-model="areaInteresse.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!areaInteresse.descricao"
                                uppercase
                                tooltipLabel="area-interesse-tooltip-descricao"
                                tooltipSize="is-small"
                                title="descricao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                :required="true"
                            />
                        </div>

                        <div class="column is-3">
                            <vss-select
                                :id="generateId(20)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="areaInteresse.id == null"
                                tooltipLabel="area-interesse-tooltip-situacao"
                                tooltipSize="is-small"
                                title="situacao"
                                :tooltipMultilined="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AreaInteresseService from '@/services/agro/AreaInteresseService';
import AreaInteresseValidation from '@/services/validations/agro/AreaInteresseValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'CLI_AREAINTERESSE'
            ),
            service: new AreaInteresseService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            areaInteresse: {
                idcliareainteresse: null,
                idareainteresseerp: null,
                descricao: '',
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            isVenda: this.$route.query.contexto == 'ven',
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'cli-areainteresse');
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cli-areainteresse' },
            });
        } else {
            this.validation = new AreaInteresseValidation(this.msgs);

            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
                this.isUpdate = true;
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.areaInteresse = value.content;
                    this.situacao = this.situacoes[this.areaInteresse.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            let areaInteresseTemp = Object.assign({}, this.areaInteresse);
            areaInteresseTemp = this.mapTosave(areaInteresseTemp);
            areaInteresseTemp.situacao = this.situacao.id;

            if (this.validation.validate(areaInteresseTemp, this.$refs)) {
                this.isSaving = true;

                this.service
                    .save(areaInteresseTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-area-interesse';
                            if (this.areaInteresse.id != null) {
                                msg = 'msg-edit-area-interesse';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToPage();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios');
                this.isLoading = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.descricao,
            };
        },
        redirectToPage() {
            if (this.$route.query.tela == 'cliente-areainteresse') {
                setTimeout(() => {
                    this.$router.push({
                        name: `${this.$route.query.contexto}-cliente-dados-cadastrais-edit`,
                        params: {
                            id: this.$route.query['id'],
                        },
                        query: {
                            dadoscadastrais: this.$route.query.dadoscadastrais,
                            politicacomercial: this.$route.query.politicacomercial,
                            analisecomercial: this.$route.query.analisecomercial,
                        },
                    });
                }, 1000);
            } else {
                setTimeout(() => {
                    this.$router.push({
                        name: 'cli-areainteresse-list',
                    });
                }, 1000);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}

.expanded-buttons {
    width: 50% !important;
}
</style>
